import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ResizeDetector from 'react-resize-detector';
import { getImageByWidth } from 'api';
import { FlexFigure } from 'msp-components';
import Error404 from 'components/Error404';

const StyledContainer = styled.div`
  background-color: #fff;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  position: relative;
  width: 100%;
`;

const ImageTitle = ({ routeProps, versions }) => {
  const [containerWidth, setContainerWidth] = useState();
  const handleResize = width => setContainerWidth(width);

  if (!routeProps.match.isExact) return <Error404 />;

  const imageUrl = (getImageByWidth(versions, containerWidth && containerWidth * 1.5) || {}).url;

  return (
    <StyledContainer>
      <ResizeDetector
        handleWidth
        onResize={handleResize}
        refreshMode="debounce"
        refreshRate={500}
      />
      <div style={{ height: '100%', padding: 20 }}>
        <FlexFigure imageUrl={imageUrl} />
      </div>
    </StyledContainer>
  );
};

ImageTitle.propTypes = {
  routeProps: PropTypes.object,
  versions: PropTypes.arrayOf(PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
    url: PropTypes.string,
  })),
};

export default ImageTitle;
